const skeleton = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1182'
		height='386'
		viewBox='0 0 1182 386'>
		<g
			id='Group_22158'
			data-name='Group 22158'
			transform='translate(-320 -8215)'>
			<rect
				id='Rectangle_2162'
				data-name='Rectangle 2162'
				width='1182'
				height='51'
				rx='4'
				transform='translate(320 8215)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2163'
				data-name='Rectangle 2163'
				width='1182'
				height='51'
				rx='4'
				transform='translate(320 8290)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2164'
				data-name='Rectangle 2164'
				width='830'
				height='51'
				rx='4'
				transform='translate(320 8365)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2165'
				data-name='Rectangle 2165'
				width='591'
				height='51'
				rx='4'
				transform='translate(320 8440)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2166'
				data-name='Rectangle 2166'
				width='263'
				height='35'
				rx='4'
				transform='translate(320 8566)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2167'
				data-name='Rectangle 2167'
				width='263'
				height='35'
				rx='4'
				transform='translate(601 8566)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2168'
				data-name='Rectangle 2168'
				width='263'
				height='65'
				rx='4'
				transform='translate(1239 8536)'
				fill='#f0f0f0'
			/>
		</g>
	</svg>
);

export { skeleton };
